import { render, staticRenderFns } from "./CastellForm.vue?vue&type=template&id=0fc056cc"
import script from "./CastellForm.vue?vue&type=script&lang=js"
export * from "./CastellForm.vue?vue&type=script&lang=js"
import style0 from "./CastellForm.vue?vue&type=style&index=0&id=0fc056cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports